var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10394 1.63075L15.8257 13.0887C16.1814 13.695 15.9754 14.4732 15.3657 14.8269C15.1702 14.9403 14.9479 15 14.7216 15H1.27815C0.572247 15 0 14.431 0 13.7291C0 13.504 0.0600838 13.2831 0.174111 13.0887L6.89586 1.63075C7.25154 1.02445 8.03417 0.819659 8.64392 1.17333C8.83437 1.2838 8.99284 1.44138 9.10394 1.63075ZM7.5 6C7.22386 6 7 6.22386 7 6.5V9.5C7 9.77614 7.22386 10 7.5 10H8.5C8.77614 10 9 9.77614 9 9.5V6.5C9 6.22386 8.77614 6 8.5 6H7.5ZM7.5 11C7.22386 11 7 11.2239 7 11.5V12.5C7 12.7761 7.22386 13 7.5 13H8.5C8.77614 13 9 12.7761 9 12.5V11.5C9 11.2239 8.77614 11 8.5 11H7.5Z",
    fill: "#EB3D1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.6e1f8c467e99aa13ef387caa01737f26.svg";
export { ForwardRef as ReactComponent };